<div class="flex-vertical gap-16 width-100pc">
  <div>
    {{ totalCount }} @if (totalCount > 1) {
    <span>fonds événementiels</span
      >
      }@if (totalCount < 2) {
      <span>fond événementiel</span>
    }
  </div>
  <div class="width-100pc">
    <oui-table>
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="fondEvenementiel">
          <th mat-header-cell *matHeaderCellDef>Libelle</th>
          <td mat-cell *matCellDef="let element">{{ element?.libelle }}</td>
        </ng-container>
        <ng-container matColumnDef="produitFondEvenementiel">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            {{ element?.produitFondEvenementiels?.length ?? '0' }}
            @if (element?.produitFondEvenementiels?.length > 1) {
              <span>produits associés</span
                >
                }@if (element?.produitFondEvenementiels?.length < 2) {
                <span>produit associé</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="actionButton">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <div class="flex-horizontal gap-16">
                <div class="flex-1"></div>
                <oui-button type="text" (click)="onDeactivateFondEvenementiel(element)">Supprimer</oui-button>
                <oui-button type="text" (click)="onUpdateFond(element)">Modifier</oui-button>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          @if (!isLoading) {
            <tr mat-row [class.interactive]="true" *matRowDef="let row; columns: displayedColumns"></tr>
          }
        </table>
        @if (isLoading) {
          <oui-loading class="flex-vertical flex-center padding-vertical-16"></oui-loading>
        }
        <oui-paginator
          [pageSizeOptions]="pageSizeOptions"
          [length]="totalCount"
          [pageIndex]="pageIndex"
          [pageSize]="pageSize">
        </oui-paginator>
      </oui-table>
    </div>
  </div>
